import { TextField, TextFieldProps } from '@mui/material';
import { useController, UseControllerProps } from 'react-hook-form';

export type TextFieldInputProps = UseControllerProps & TextFieldProps;

const TextFieldInput = ({ name, control, rules, defaultValue, onChange, ...TextFieldProps }: TextFieldInputProps) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    name,
    control,
    rules,
    defaultValue
  });

  return (
    <TextField
      {...field}
      onChange={(...args) => {
        field.onChange(...args);
        onChange?.(...args);
      }}
      error={!!error}
      helperText={error?.message}
      variant="outlined"
      required={!!rules?.required}
      {...TextFieldProps}
    />
  );
};

export default TextFieldInput;
